<script>
import Logo from "@/components/ui/Logo";

export default {
  name: "PageFooter",
  components: {
    Logo
  }
};
</script>

<style lang="stylus" scoped>
@import "PageFooter"
</style>
